import { render, staticRenderFns } from "./InfoPagesForm.vue?vue&type=template&id=8036c43e"
import script from "./InfoPagesForm.vue?vue&type=script&lang=js"
export * from "./InfoPagesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports